import { Injectable } from '@angular/core';

import { QuoteModel } from '@bytel/bytel-sales';

import { Observable, Subject } from 'rxjs';

import { MobileRecoveryStatus, MobileRecoverySteps } from '../interfaces/mobile-recovery.interface';
import { MobileRecoveryModel } from '../models/mobile-recovery.model';
import { MobileRecoveryRepository } from '../repositories/mobile-recovery.repository';

@Injectable({
    providedIn: 'root',
})
export class MobileRecoveryService {
    public recoveryActionObs: Observable<void>;
    private _recoveryActionSubject: Subject<void> = new Subject();

    public constructor(private mobileRecoveryRepository: MobileRecoveryRepository) {
        this.recoveryActionObs = this._recoveryActionSubject.asObservable();
    }

    public init(): void {
        this._recoveryActionSubject.next(null);
    }

    public delete(productId: string): void {
        this.mobileRecoveryRepository.remove(productId);
        this._recoveryActionSubject.next(null);
    }

    public start(recovery: MobileRecoveryModel): MobileRecoveryModel {
        recovery.product = null;
        recovery.recovery = null;
        recovery.status = MobileRecoveryStatus.UNSTARTED;
        recovery.step = MobileRecoverySteps.START;
        return recovery;
    }

    public getRecoveryForQuote(quote: QuoteModel): MobileRecoveryModel {
        return this.mobileRecoveryRepository.getMobileRecovery(quote);
    }
}
